import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../CSS/private/PageContent_SideBar.css';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

/**
 * @param {*} props - header          = an array of column headers
 *                  - body            = a 2-D array of data values in form [[row], [row], [row]]
 *                  - editFunction    = the function to call when editing information - calls the function with the parameter of the row's index
 *                  - deleteFunction  = the function to call when deleting information - calls the function with the parameter of the row's index
 *                  - numbered        = flag to show the entries with a number
 */
function SubTabTable(props) {

  const smallColumnWidth = '25px';

  const narrow = props.narrow;
  var header = props.header;
  const body = props.body;
  const editFunction = props.editFunction;
  const deleteFunction = props.deleteFunction;
  const numbered = props.numbered;
  const initialHeaderLength = header.length;
  
  var smallColumns = 0;
  if(numbered) smallColumns++
  if(editFunction !== undefined) smallColumns++;
  if(deleteFunction !== undefined) smallColumns++;
  
  const columnWidth = 'calc(' + (100 / initialHeaderLength) + '% - ' + (smallColumns * 25 / initialHeaderLength) + 'px)';
  

  const sectionTitle = (props.title !== undefined)? (
    <div className='slp-subtab-section-title'>
      {props.title}
    </div>
   ) : null

   const sectionDescription = (props.description !== undefined)? (
    <div className='slp-subtab-section-description'>
      {props.description}
    </div>
   ) : null

   const sectionDetails = (props.title !== undefined || props.description !== undefined)? (
    <div className={'slp-subtab-details' + (props.narrow? '-narrow' : '')}>
      {sectionTitle}
      {sectionDescription}
    </div>
   ) : null;


  var headerColumns = header.map((column, i) => {
    return (<Column key={i} width={columnWidth} data={column} />)
  })

  // Add additional header columns depending on settings
  if(numbered) {
    headerColumns = [(<Column key='edit' smallColumn width={smallColumnWidth}/>), ...headerColumns]
  }

  if(props.editFunction !== undefined) {
    headerColumns = [...headerColumns, (<Column key='edit' smallColumn width={smallColumnWidth}/>)]
  }

  if(props.deleteFunction !== undefined) {
    headerColumns = [...headerColumns, (<Column key='delete' smallColumn width={smallColumnWidth}/>)]
  }


  let tableContent = body.map((row, i) => {

    var rowContent = row.map((column, j) => {
      return (<Column key={j} width={columnWidth} data={column} />)
    })

    if(numbered) {
      rowContent = [(<Column key='number' smallColumn number width={smallColumnWidth} data={i+1} />), ...rowContent]
    }

    if(props.editFunction !== undefined) {
      rowContent = [...rowContent, (<Column key='edit' smallColumn width={smallColumnWidth} data={<FontAwesomeIcon icon={faEdit} style={{...{color: '#3498db'},...{cursor: 'pointer'}}} onClick={() => {editFunction(i)}} />} />)]
    }

    if(props.deleteFunction !== undefined) {
      rowContent = [...rowContent, (<Column key='delete' smallColumn width={smallColumnWidth} data={<FontAwesomeIcon icon={faTrash} style={{...{color: '#e74c3c'},...{cursor: 'pointer'}}} onClick={() => {deleteFunction(i)}} />} />)]
    }
    return (<div key={i} className={'slp-subtab-table-row' + (i === body.length - 1? '' : '-bordered')}>{rowContent}</div>);
  })


  return (

    <div className='slp-subtab-section-container'>
      {sectionDetails}
      <div className={'slp-subtab-table' + (narrow? '-narrow' : '')}>

        <div className='slp-subtab-table-header-row'>
          {headerColumns}
        </div>
        {tableContent}

      </div>
    </div>

  )

}

export default SubTabTable;



function Column(props) {
  return (
    <div className={'slp-subtab-table-column' + (props.smallColumn? '-small' : '')}
         style={{
          ...{width: props.width},
          ...(props.data === null)? {color: '#555555'} : null,
          ...(props.number)? {color: '#777777'} : null,
          ...(props.number)? {fontSize: '12px'} : null,
          ...(props.number)? {fontWeight: '600'} : null,
        }}
    >
      {props.data !== null? props.data : 'n/a'}
    </div>)
}